import axios from "axios";

class TrackRepository {
  constructor(callback) {
    this.callback = callback;
  }

  async getResources() {
    let url = `/api/home/getresourcedetail`;
    const response = await axios({ method: "get", url })
      .then((response) => {
        return response.data;
      })
      .catch((error) => ({ error: JSON.stringify(error) }));
    return response;
  }
  async addResources(payload) {
    let url = `/api/home/addresources`;
    const response = await axios({
      method: "post",
      url,
      data: payload,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => ({ error: JSON.stringify(error) }));
    return response;
  }
  async deleteResources(id) {
    let url = `/api/home/deleteresources?id=${id}`;
    const response = await axios({ method: "delete", url })
      .then((response) => {
        return response.data;
      })
      .catch((error) => ({ error: JSON.stringify(error) }));
    return response;
  }
  async getResourcesList() {
    let url = `/api/home/getresources`;
    const response = await axios({ method: "get", url })
      .then((response) => {
        return response.data;
      })
      .catch((error) => ({ error: JSON.stringify(error) }));
    return response;
  }

  async getWorks() {
    let url = `/api/home/getworks`;
    const response = await axios({ method: "get", url })
      .then((response) => {
        return response.data;
      })
      .catch((error) => ({ error: JSON.stringify(error) }));
    return response;
  }

  async addWorks(payload) {
    let url = `/api/home/addworks`;
    const response = await axios({
      method: "post",
      url,
      data: payload,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => ({ error: JSON.stringify(error) }));
    return response;
  }
  async deleteWorks(id) {
    let url = `/api/home/deleteworks?id=${id}`;
    const response = await axios({ method: "delete", url })
      .then((response) => {
        return response.data;
      })
      .catch((error) => ({ error: JSON.stringify(error) }));
    return response;
  }

  async addAboutMedia(payload, isFile = false) {
    let url = `/api/home/addmedia`;

    try {
      let response;

      if (isFile) {
        // Case: video or multiple files upload (use FormData)
        const formData = new FormData();

        formData.append("section", payload.section);
        formData.append("mediaType", payload.mediaType);
        formData.append("altText", payload.altText || "");

        if (Array.isArray(payload.media)) {
          payload.media.forEach((file) => {
            formData.append("media", file);
          });
        } else {
          formData.append("media", payload.media); // single file
        }

        response = await axios.post(url, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        // Case: image upload (base64 JSON)
        response = await axios.post(url, payload, {
          headers: { "Content-Type": "application/json" },
        });
      }

      return response.data;
    } catch (error) {
      console.error("Upload error:", error.response?.data || error.message);
      return { error: error.response?.data || "Unexpected Error" };
    }
  }

  async deleteMedia(id) {
    let url = `/api/home/deletemedia/${id}`;
    try {
      const response = await axios.delete(url);
      return response.data;
    } catch (error) {
      return { error: error.response?.data || "Unexpected Error" };
    }
  }
  async getAboutMedia(section = "about", mediaType) {
    let url = `/api/home/getmedia?section=${section}`;
    if (mediaType) url += `&mediaType=${mediaType}`;
    const response = await axios({ method: "get", url })
      .then((response) => {
        return response.data;
      })
      .catch((error) => ({ error: JSON.stringify(error) }));
    return response;
  }

  async setActiveAboutMedia(payload) {
    let url = `/api/home/setactiveaboutmedia`;
    try {
      const response = await axios.post(url, payload);
      console.log("Response from setActiveAboutMedia:", response.data);
      return response.data;
    } catch (error) {
      return { error: error.response?.data || "Unexpected Error" };
    }
  }

  async addTestimony(payload) {
    let url = `/api/home/addtestimony`;
    try {
      // If image is base64, send as JSON
      const response = await axios.post(url, payload, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      return { error: error.response?.data || "Unexpected Error" };
    }
  }

  async getTestimonies() {
    let url = `/api/home/gettestimonies`;
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      return { error: error.response?.data || "Unexpected Error" };
    }
  }

  async deleteTestimony(id) {
    let url = `/api/home/deletetestimony/${id}`;
    try {
      const response = await axios.delete(url);
      return response.data;
    } catch (error) {
      return { error: error.response?.data || "Unexpected Error" };
    }
  }

  async getLeadership() {
    let url = `/api/home/getleadership`;
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      return { error: error.response?.data || "Unexpected Error" };
    }
  }

  async addLeadership(payload) {
    let url = `/api/home/addleadership`;
    try {
      const response = await axios.post(url, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return { error: error.response?.data || "Unexpected Error" };
    }
  }

  async deleteLeadership(id) {
    let url = `/api/home/deleteleadership/${id}`;
    try {
      const response = await axios.delete(url);
      return response.data;
    } catch (error) {
      return { error: error.response?.data || "Unexpected Error" };
    }
  }
}

export default new TrackRepository();
